<template>
  <v-container fluid class="pa-0">
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center>
        <GmapMap
          :center="{lat: 44.428212, lng: 26.1494952}"
          :zoom="12"
          map-type-id="roadmap"
          style="width: 100%; height: calc(100vh - 48px - 36px)"
          @click="mapClick"
          :options="{
            mapTypeControl: true,
            mapTypeControlOptions: {
              mapTypeIds: ['hybrid', 'roadmap', 'terrain', 'satellite']
            }
          }">
          <gmap-polygon
            v-for="layer in layers"
            v-if="layer.selected && layer.coords.length"
            :key="layer.id"
            :editable="layer.edit"
            :path="layer.coords"
            :draggable="layer.drag"
            @path_changed="updateCoords($event, layer.id)"
            :options="{
              strokeColor: layer.color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: layer.color,
              fillOpacity: 0.35
            }">
          </gmap-polygon>

          <gmap-cluster v-if="project && project.markers.length" :max-zoom="clusteringLevel">
            <template v-for="(marker, index) in project.markers">
              <template v-if="showMarker(marker)">
                <template v-if="getMarkerIcon(marker)">
                  <gmap-marker
                    :position="{lat: +marker.lat, lng: +marker.lng}"
                    :icon="{
                      url: getMarkerIcon(marker),
                      scaledSize: new google.maps.Size(200 * .1, 320 * .1),
                      origin: new google.maps.Point(0, 0), // origin
                      anchor: new google.maps.Point(200 * .1, 320 * .1) // anchor
                    }"
                    :title="markerTitle(marker)"
                    :key="index">
                  </gmap-marker>
                </template>
                <template v-else>
                  <gmap-marker
                    :position="{lat: +marker.lat, lng: +marker.lng}"
                    :title="markerTitle(marker)"
                    :key="index">
                  </gmap-marker>
                </template>
              </template>
            </template>
          </gmap-cluster>
        </GmapMap>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'

const SERVER_URL = process.env.NODE_ENV === 'production' ? 'https://newlayers.verdedata.ro' : 'http://localhost:3535'

export default {
  name: 'map-component',
  data () {
    return {
      markerIcon: `
        M365.027,44.5c-30-29.667-66.333-44.5-109-44.5s-79,14.833-109,44.5s-45,65.5-45,107.5    c0,25.333,12.833,67.667,38.5,127c25.667,59.334,51.333,113.334,77,162s38.5,72.334,38.5,71c4-7.334,9.5-17.334,16.5-30    s19.333-36.5,37-71.5s33.167-67.166,46.5-96.5c13.334-29.332,25.667-59.667,37-91s17-55,17-71    C410.027,110,395.027,74.167,365.027,44.5z M289.027,184c-9.333,9.333-20.5,14-33.5,14c-13,0-24.167-4.667-33.5-14    s-14-20.5-14-33.5s4.667-24,14-33s20.5-13.5,33.5-13.5c13,0,24.167,4.5,33.5,13.5s14,20,14,33S298.36,174.667,289.027,184z
      `
    }
  },
  computed: {
    google: gmapApi,
    layers () {
      return this.$store.getters.layers
    },
    layer () {
      return this.$store.getters.currentLayer
    },
    project () {
      return this.$store.getters.currentProject
    },
    clusteringLevel () {
      if (this.project) {
        return this.project.clusteringLevel
      }
      return 15
    }
  },
  methods: {
    getMarkerIcon (marker) {
      let url = null
      const layer = this.layers.find(layer => layer.id === marker.layer)

      if (layer) {
        url = `${SERVER_URL}/icons/${layer.color.slice(1)}.png`
      }
      // console.log(url)
      return url
    },
    markerTitle (marker) {
      const adresa = marker['Denumire bloc de locuinte in lista prioritizare'] || ''
      const id = marker['Id (Prio)'] || ''

      return `${id} - ${adresa}`
    },
    showMarker (marker) {
      if (marker.layer) {
        const layer = this.layers.find(layer => layer.id === marker.layer)
        if (layer && layer.showMarkers) {
          return true
        } else {
          return false
        }
      } else {
        if (this.project.showMarkers) {
          return true
        } else {
          return false
        }
      }
    },
    markerColor (marker) {
      if (marker.layer) {
        const layer = this.layers.find(layer => layer.id === marker.layer)
        return layer ? layer.color : '#000000'
      }
      return '#000000'
    },
    mapClick (event) {
      if (this.layer && this.layer.coords.length < 3) {
        this.$store.commit('setLayerCoord', event.latLng)
      }
    },
    updateCoords (event, layerID) {
      this.$store.commit('setLayerPath', {coords: event.getArray(), id: layerID})
    }
  }
}
</script>
